module.exports = __webpack_public_path__ + "static/img/ico_check2_on.8efbe11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/ico_check2_on.svg
// module id = 06JJ
// module chunks = 10